"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWordTableListData = void 0;
const fast_json_stable_stringify_1 = __importDefault(require("fast-json-stable-stringify"));
const mingo_1 = require("mingo");
const models_hook_1 = require("app/models.hook");
const react_1 = require("react");
const wordTable_1 = require("@/schemaComponents/modules/hooks/wordTable");
const useWordTableListData = ({ projectId, langId, condition, }) => {
    const langAppliedCondition = (0, react_1.useMemo)(() => {
        var _a;
        return Object.fromEntries(((_a = Object.entries(condition || {})) === null || _a === void 0 ? void 0 : _a.filter(([key]) => {
            const keyComponents = key.split(".");
            if (keyComponents.length !== 2)
                return true;
            const keyLangId = key.split(".")[1];
            return keyLangId === langId;
        })) || []);
    }, [condition, langId]);
    // Segment level
    const { list, loading, hasMore, fetching, refresher, reload } = (0, models_hook_1.useWordTableList)({
        projectId,
        condition: langAppliedCondition,
    });
    const segmentLevelWordTable = (0, react_1.useMemo)(() => list.map((script) => (Object.assign(Object.assign({}, script), { level: "ファイル" }))), [list]);
    // Project level
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const { value: wordTable } = (0, wordTable_1.useWordTable)(projectData.wordList) || {};
    const projectLevelWordTable = (0, react_1.useMemo)(() => wordTable === null || wordTable === void 0 ? void 0 : wordTable.words.map((word, index) => ({
        text: word,
        translations: Object.keys(wordTable.translations).reduce((obj, langId) => {
            obj[langId] = wordTable.translations[langId][index];
            return obj;
        }, {}),
        level: "プロジェクト",
        scriptId: wordTable.scriptIds[index],
    })), [wordTable]);
    const filter = (0, react_1.useMemo)(() => {
        const mingoQuery = new mingo_1.Query(langAppliedCondition || {});
        return mingoQuery.test.bind(mingoQuery);
    }, [(0, fast_json_stable_stringify_1.default)(langAppliedCondition)]);
    const filteredProjectLevel = (0, react_1.useMemo)(() => {
        return projectLevelWordTable === null || projectLevelWordTable === void 0 ? void 0 : projectLevelWordTable.filter(filter);
    }, [projectLevelWordTable, filter]);
    const combinedList = [
        ...segmentLevelWordTable,
        ...(filteredProjectLevel || []),
    ];
    return {
        list: combinedList,
        loading,
        hasMore,
        fetching,
        refresher,
        reload,
    };
};
exports.useWordTableListData = useWordTableListData;
